import React, { Component } from 'react';
import Project from '../../Components/Project/Project';
// import firebase, { FirebaseContext, db } from "../../Components/Firebase";
// import { getStorage, ref, set, onValue } from "firebase/database";
import DB from '../../Config/db';

// import app from 'firebase/app';
import { Link } from 'react-router-dom';

// import './iso';
import './style.css';
import './plugin';

export default class PortfolioSection extends Component {
  constructor(props) {
    super(props);
    // let projects = firebase.database().ref('/projects');
    // var userId = firebase.auth().currentUser.uid;
    this.state = {
      projects: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    // let myRef = ref(db,'Projects');
    // onValue(myRef,(s)=> {
    //   console.log("P: ", Object.values(s.val()));
    //   this.setState({
    //     projects: Object.values(s.val())
    //   });
    // }, (err)=>{
    //   console.log("Err : ", err);
    // })
    this.setState({
      projects: DB.projects,
    });
  };

  render() {
    return (
      <section className='dark-bg page-section' id='portfolio'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 text-center'>
              <h2 className='section-heading dark text-uppercase'>Portfolio</h2>
              <h3 className='section-subheading gold '>Samples of my Work</h3>
            </div>
          </div>
          <div className='row filterBtns d-flex justify-content-center'>
            <div className='btn-group' role='group' aria-label='Basic example'>
              <button
                type='button'
                className='btn filterBtn activeBtn'
                data-filter='all'
              >
                All
              </button>
              <button type='button' className='btn filterBtn' data-filter='web'>
                Web
              </button>
              <button
                type='button'
                className='btn filterBtn'
                data-filter='mobile'
              >
                Mobile
              </button>
            </div>
          </div>
          <div className='row' id='projectsContaner'>
            {this.state.projects.length > 0
              ? this.state.projects.map((project, index) => {
                  return (
                    // <div style={{
                    //   width:'100%',
                    //   display:'flex',
                    //   justifyContent:'center',
                    //   alignItems:'center',
                    //   backgroundColor:'red'
                    // }}>
                    <Link
                      key={'linkP-' + index}
                      to={`/project/${index}`}
                      className={`col-md-4 col-sm-6 text-center projectItem ${project.type}  animated slow`}
                    >
                      <Project
                        data={{
                          projectName: project.name,
                          projectDesc: project.desc,
                          projectImg: project.cardCover || project.cover,
                        }}
                        type={project.type}
                      />
                    </Link>
                    // </div>
                  );
                })
              : null}
          </div>
        </div>
      </section>
    );
  }
}
